import { Icon } from '@aibees/shared/components';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditRuleCoinProps as Props } from './types';

export const CreditRuleCoin = memo(({ className, icon, sx, type }: Props) => {
  const { credit } = useCreditUsageItem(type);

  return (
    <Styled.Wrapper
      className={classnames('CreditRuleCoin', className)}
      sx={mergeSx(SX.root, sx)}
    >
      <Styled.Chip
        variant="outlined"
        color="primary"
        size="small"
        label={
          <Box sx={SX.chipContent}>
            {credit ?? 'Free'} x
            <Icon size={14} name={icon ?? 'coin'} />
          </Box>
        }
      />
    </Styled.Wrapper>
  );
});

CreditRuleCoin.displayName = 'CreditRuleCoin';
